// extracted by mini-css-extract-plugin
export default {"frame":"StyleCardPreview_frame__Dl8l2","page":"StyleCardPreview_page__7QSNd","placeholder":"StyleCardPreview_placeholder__m-sud"};